import React from "react";

export default function SearchIcon() {
  return (
    <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M13.8227 7.94653C13.8227 11.3558 11.0589 14.1196 7.64964 14.1196C4.24035 14.1196 1.47656 11.3558 1.47656 7.94653C1.47656 4.53722 4.24035 1.77344 7.64964 1.77344C11.0589 1.77344 13.8227 4.53722 13.8227 7.94653Z" stroke="black"/>
      <path d="M12.224 11.579L15.5071 14.8621" stroke="black"/>
    </svg>
  );
}
